// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-wrapper":"breadcrumbs-module--breadcrumbs-wrapper--2GOpM","separator":"breadcrumbs-module--separator--1o3nR"};